import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { ScreenService } from '@m4u-angular/core/framework/screen.service';
import { DxButtonComponent } from 'devextreme-angular';

@Component({
    selector: 'm4u-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss']
})
export class ButtonComponent {
    @Input() Mode: 'transparent' | 'light' | 'base' | 'solid' | 'text';
    @Input() Type: 'success' | 'danger' | 'normal' | 'default';
    @Input() Size: 'default' | 'large' | 'small' = 'default';
    @Input() Icon: string;
    @Input() TabIndex: number;
    @Input() Text: string;
    @Input() Hint: string;
    @Input() Class: string;
    @Input() Visible = true;
    @Input() FocusStateEnabled: boolean;
    @Input() Disabled: boolean;
    @Input() IsRound: boolean;
    @Input() IsFullWidth: boolean;
    @Input() IsHideTextOnMobile: boolean;
    @Input() IsLoading: boolean;
    @Input() DoNotUseIconColorForText: boolean;
    @Output() OnClick: EventEmitter<any> = new EventEmitter;

    @ViewChild('btn') btn: DxButtonComponent;

    private _id: string;
    get ID() {
        if (!this._id) this._id = 'btn_' + Math.random().toString(36).replace('0.', '');
        return this._id;
    }

    constructor(public screen: ScreenService) {
    }

    GetClass() {
        return `${this.Class || ''} ${this.Mode ? ('btn-' + this.Mode) : ''} ${this.IsRound ? ' btn-round' : ''} btn-size-${this.Size} ${this.DoNotUseIconColorForText ? 'do-not-use-icon-color-for-text' : ''}`;
    }

    GetText() {
        return this.screen.IsMobile() && this.IsHideTextOnMobile ? '' : this.Text;
    }

    GetStylingMode() {
        switch (this.Mode) {
            case 'transparent':
            case 'base':
                return 'outlined';
            case 'solid':
                return 'contained';
            case 'light':
            case 'text':
                return 'text';
        }
    }

    Click(e) {
        this.OnClick.emit(e.event);
    }

    Repaint() {
        this.btn && this.btn.instance && this.btn.instance.repaint();
    }

    OnTooltipShowing(e) {
        e.component?.content()?.parentElement?.classList?.add('button-tooltip');
    }

}
